import React, { memo, useMemo } from "react";
import "./ShowcaseAnnouncementCard.scss";

const badgeLabel = (annType) => {
  if (annType === "slots") return "Вільні вікна";
  if (annType === "promo") return "Акція";
  if (annType === "newNearby") return "Новий майстер поруч";
  return "Оголошення";
};

const ShowcaseAnnouncementCard = memo(function ShowcaseAnnouncementCard({
  item,
  timeAgo,
  onOpen,
}) {
  const text = String(item?.text || "").trim();
  const title = item?.title ? String(item.title) : "";
  const city = item?.city ? String(item.city) : "";
  const coverUrl = item?.coverUrl ? String(item.coverUrl) : "";

  const label = useMemo(
    () => badgeLabel(item?.annType || item?.type),
    [item?.annType, item?.type]
  );

  return (
    <div className="sa-feedCard">
      {}
      <div className="sa-feedCard__cover">
        {coverUrl ? (
          <img src={coverUrl} alt="" loading="lazy" />
        ) : (
          <div className="sa-feedCard__coverPh">Обкладинка</div>
        )}

        {}
        {!!timeAgo && <div className="sa-feedCard__time">{timeAgo}</div>}
      </div>

      <div className="sa-feedCard__body">
        {}
        {(title || city) && (
          <div className="sa-feedCard__meta">
            {title && <div className="sa-feedCard__title">{title}</div>}
            {city && <div className="sa-feedCard__city">{city}</div>}
          </div>
        )}

        <div className="sa-feedCard__badge">{label}</div>

        <div className="sa-feedCard__text">{text || "Текст оголошення…"}</div>

        <button
          type="button"
          className="sa-feedCard__cta"
          onClick={() => {
            if (!item?.showcaseId) return;
            if (typeof onOpen === "function") onOpen(String(item.showcaseId));
          }}
        >
          Перейти у вітрину
        </button>
      </div>
    </div>
  );
});

export default ShowcaseAnnouncementCard;
